// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__6JW1b","tyre":"style_tyre__78ZL8"};